var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 29,
    viewBox: "0 0 43 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1271_1830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.789062 4.39681C0.789062 2.48197 2.34135 0.929688 4.25618 0.929688H38.9274C40.8422 0.929688 42.3945 2.48197 42.3945 4.39681V25.1995C42.3945 27.1144 40.8422 28.6666 38.9274 28.6666H4.25618C2.34134 28.6666 0.789062 27.1144 0.789062 25.1995V4.39681Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3656 14.8596C30.3656 10.7046 26.8976 7.83273 23.0976 7.83398H19.8276C15.9823 7.83261 12.8174 10.7055 12.8174 14.8596C12.8174 18.66 15.9824 21.7825 19.8276 21.7641H23.0976C26.8973 21.7823 30.3656 18.659 30.3656 14.8596Z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8483 8.42285C16.3347 8.42394 13.4876 11.2777 13.4863 14.7998C13.4872 18.3214 16.3344 21.1747 19.8483 21.176C23.3627 21.175 26.2106 18.3214 26.2111 14.7998C26.2106 11.2777 23.3628 8.42411 19.8483 8.42285Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8271 14.7827C15.8305 13.0616 16.9032 11.5939 18.4159 11.0107V18.5538C16.9032 17.9709 15.8305 16.504 15.8271 14.7827V14.7827ZM21.3022 18.5557V11.011C22.8155 11.5928 23.8899 13.0613 23.8926 14.7831C23.8899 16.5056 22.8155 17.973 21.3022 18.5559V18.5557Z",
    fill: "#0079BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_1830"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.789062,
    y: 0.929688,
    width: 41.6054,
    height: 27.737,
    rx: 5.77853,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/dinersClub.102d2a5e013adee0827e715973be9fd2.svg";
export { ForwardRef as ReactComponent };